import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Draggable, Position } from 'react-beautiful-dnd';
import InformationCard from './InformationCard';
import { IdeaBoxEntry } from 'konect-model';
import { GlyphEvent, GlyphEventService } from '../../services/event-service';

interface TaskViewProps {
  index: number;
  entry: IdeaBoxEntry;
  animateToRef?: any;
  onHover?: (entry: IdeaBoxEntry, hover: boolean) => void;
}
/**
type DropReason = 'DROP' | 'CANCEL';

type DropAnimation = {
  // how long the animation will run for
  duration: number,
  // the animation curve that we will be using for the drop
  curve: string,
  // the x,y position will be be animating to as a part of the drop
  moveTo: Position,
  // when combining with another item, we animate the opacity when dropping
  opacity?: number,
  // when combining with another item, we animate the scale when dropping
  scale?: number,
};
 */

function getStyle(style: any, snapshot: any, position?: Position) {
  if (!snapshot.isDropAnimating) {
    return style;
  }
  let { moveTo } = snapshot.dropAnimation;
  let scale = 'scale(1)';
  if (position && (position.x !== 0 || position.y !== 0)) {
    moveTo.x += position.x - 20;
    moveTo.y += position.y;
    scale = 'scale(0.0)';
  } else if (position) {
    scale = 'scale(2.0)';
    moveTo = position;
  }
  // move to the right spot
  const translate = `translate(${moveTo.x}px, ${moveTo.y}px)`;
  return {
    ...style,
    transform: `${translate} ${scale}`
  };
}

const Container: any = styled.div`
  padding: 8px;
`;

const TaskView = (props: TaskViewProps) => {

  const [dim, setDim] = useState(false);

  useEffect(() => {
    props.animateToRef && GlyphEventService.on(GlyphEvent.HIGHLIGHT_ENTRIES, (entries : IdeaBoxEntry[]) => {
        if (!entries || entries.length <= 0) {
            setDim(false);
            return;
        }
        if (!entries.find(e => e.id === props.entry.id)){
            setDim(true);
        }            
    })
}, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Draggable draggableId={props.entry.id} index={props.index}>
      {(provided, snapshot) => <>
          <div onMouseEnter={() => props.onHover && props.onHover(props.entry, true)}
            onMouseLeave={(e) => { props.onHover && !snapshot.isDragging && props.onHover(props.entry, false) }}
          >
            <Container
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
              isDragging={snapshot.isDragging}
              style={props.animateToRef && !snapshot.isDragging ? {transform: "none"} : getStyle(provided.draggableProps.style, snapshot, props.animateToRef?.current)}
            >
              <div style={props.animateToRef && snapshot.isDragging ? {transform: "scale(0.5)", opacity: "0.5", transition: "all 0.2s ease"} : {}}>
              <InformationCard entry={props.entry} dim={dim}/>
              </div>
            </Container>
          </div>
           {props.animateToRef && snapshot.isDragging ? 
           <Container>
            <InformationCard entry={props.entry} dim={dim} />
            </Container> : null}
           </>}
    </Draggable>);
}


export default TaskView;